import React from 'react';
import { Select } from 'antd';
import type { SelectProps } from 'antd';
import { useOneButtonStore } from '../../../../../store/oneButtonStore';

export type OBDSelectProps<ValueType = any, OptionType extends object = any> = SelectProps<ValueType, OptionType>;

const OBDSelect = <ValueType, OptionType extends object = any>({
    className,
    popupClassName,
    ...props
}: OBDSelectProps<ValueType, OptionType>) => {
    const theme = useOneButtonStore((s) => s.theme);
    const mergedClassName = className ? `obd-utility__select ${className}` : 'obd-utility__select';
    const mergedPopupClassName = popupClassName
        ? `${popupClassName} obd-select-dropdown obd-theme-${theme}`
        : `obd-select-dropdown obd-theme-${theme}`;

    return (
        <Select<ValueType, OptionType>
            {...props}
            className={mergedClassName}
            popupClassName={mergedPopupClassName}
        />
    );
};

export default OBDSelect;
